import axios from './axios';
import { ContactFromType } from '../types';

export const postUserContact = async (forms: ContactFromType, token: string): Promise<any> => {
  const result = await axios.post(`/v1/ext/user-contact/${token}`, forms);
  return result;
};

export const getUserContactInfo = async (token: string, language?: string): Promise<any> => {
  const result = await axios.get(`/v1/ext/user-contact?token=${token}`, {
    headers: { language },
  });
  return result;
};
